import { Component, type ReactNode } from 'react';
import type { MultiLang } from '../../../config';
import Functions from '../../../functions';
import type { Item } from '../../lib/ItemUtil';

export interface DetailBaseField {
    label: string;
    value: ReactNode;
}

export interface DetailBaseProps {
    lang: MultiLang;
    item: Item;
    // Leaves out the index and related item rows when set.
    isBaseItem?: boolean;
}

class DetailBase extends Component<DetailBaseProps> {
    getFields(): DetailBaseField[] {
        return [];
    }

    render() {
        const { lang, isBaseItem } = this.props;
        const fields = isBaseItem
            ? this.getFields().filter(
                  (field) => field.label !== 'Index' && field.label !== '[en]Related to[/en][ja]関連アイテム[/ja]'
              )
            : this.getFields();
        const elements = fields.map((value, idx) => {
            const evenodd = idx % 2 === 0 ? 'even' : 'odd';
            return (
                <tr key={value.label}>
                    <td className="head">{Functions.mlang(value.label, lang)}</td>
                    <td className={evenodd}>{value.value}</td>
                </tr>
            );
        });
        return (
            <table className="outer itemDetail">
                <tbody>{elements}</tbody>
            </table>
        );
    }
}

export default DetailBase;
